import { Suspense } from 'react';

import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import PinchZoom from '#client/components/PinchZoom';

import {
  ActionBoxStyled,
  ButtonStyled,
  CloseButtonStyled,
  DialogActionsStyled,
  DialogStyled,
  DialogTitleStyled,
  ImageStyled,
  TitleStyled
} from './ViewCapturedModal.styles';

export default function ViewCapturedModal({ title, base64Image, handleClose, handleRetake }) {
  const handleRetakeAndClose = () => {
    handleRetake();
    handleClose();
  };

  const handleUsePhotoAndClose = () => {
    handleClose();
  };

  return (
    <DialogStyled
      disableRestoreFocus
      fullScreen
      onClose={handleClose}
      open
    >
      <DialogTitleStyled component="div">
        <Box
          textAlign="center"
          width="100%"
        >
          <TitleStyled
            align="center"
            size="xl"
            weight="medium"
          >
            {title}
          </TitleStyled>
        </Box>
        <Box
          aria-label="Close modal"
          onClick={handleClose}
        >
          <CloseButtonStyled color="primary" />
        </Box>
      </DialogTitleStyled>
      <Suspense fallback={<div />}>
        <Stack
          height="100%"
          justifyContent="center"
          width="100%"
        >
          <PinchZoom centerOnInit>
            <ImageStyled
              alt={title}
              role="img"
              src={base64Image}
            />
          </PinchZoom>
        </Stack>
      </Suspense>
      <DialogActionsStyled>
        <ActionBoxStyled>
          <ButtonStyled
            color="error"
            onClick={handleRetakeAndClose}
            size="large"
            variant="contained"
          >
            Retake
          </ButtonStyled>
          <ButtonStyled
            onClick={handleUsePhotoAndClose}
            size="large"
            variant="contained"
          >
            Use photo
          </ButtonStyled>
        </ActionBoxStyled>
      </DialogActionsStyled>
    </DialogStyled>
  );
}

ViewCapturedModal.propTypes = {
  title: PropTypes.string.isRequired,
  base64Image: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleRetake: PropTypes.func.isRequired
};
